import { BOOKINGS_SUCCESS_SEARCH, BOOKINGS_START_SEARCH, BOOKINGS_FAILURE_SEARCH, BOOKINGS_UPDATED_FILTERS, BOOKINGS_SELECT_BOOKING } from '../actions/searchBooking'
import createReducer from '../createReducer'

const initialSearchBookingState = {
  // Search status and data
  bookings: [],
  isLoading: true,
  isFailure: false,
  // Filters from database
  filters: {
    status: [],
    provider: [],
  },
  // Filters
  colsToShow: ['type', 'bookedOn', 'reservationStatus', 'passengerName', 'provider', 'pnrLocator', 'bookedForDate'],
  textToSearch: '',
  pnrLocator: '',
  limit: 30,
  channels: [],
  brands: [],
  delegations: [],
  providers: [],
  company: '',
  type: 'all',
  bookedOn: ['', ''],
  bookedForDate: ['', ''],
  issueDateLimit: ['', ''],
  reservationStatus: 'all',
  page: 0,
  totalBookings: 0,
  checked:0,
  sortByField: 'bookedOn',
  sortType: 'desc',
}

export default createReducer(initialSearchBookingState, {
  [BOOKINGS_START_SEARCH](state, action) {
    const newState = { ...state, isLoading: true, isFailure: false }

    return newState
  },
  [BOOKINGS_FAILURE_SEARCH](state, action) {
    const newState = { ...state, isLoading: false, isFailure: true }

    return newState
  },
  [BOOKINGS_SUCCESS_SEARCH](state, { payload }) {
    const newState = {
      ...state,
      filters: { ...state.filters, ...payload.filters },
      isLoading: false,
      isFailure: false,
      bookings: payload.results,
      totalBookings: payload.totalBookings,
    }

    return newState
  },
  [BOOKINGS_UPDATED_FILTERS](state, action) {
    const newState = { ...state, [action.field]: action.value }

    return newState
  },
  [BOOKINGS_SELECT_BOOKING](state, payload) {
    const newState = { ...state, bookings: payload.bookings, checked:payload.checked }
    return newState
  },
})
